import {
  QueryMode,
  SortDirection,
} from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { useVenueListQuery } from "@ticketingplatform/api/dist/venue";
import { useDebouncedValue } from "hooks/useDebouncedValue";
import { useAutoComplete } from "hooks/useAutoComplete";

import { UseVenueSelect } from "./types";

export const useVenueSelect: UseVenueSelect = (props) => {
  const [searchValue, debouncedSearch, onSearch] = useDebouncedValue<
    string | undefined
  >(undefined, 1000);

  const { data, loading } = useVenueListQuery({
    variables: {
      addressInclude: false,
      organizationInclude: false,
      orderBy: [{ name: SortDirection.asc }],
      take: 10,
      filters: debouncedSearch
        ? {
            name: {
              contains: debouncedSearch,
              mode: QueryMode.insensitive,
            },
          }
        : undefined,
    },
  });

  return useAutoComplete({
    ...props,
    loading,
    searchValue,
    onSearch,
    options: data?.venues?.nodes || [],
    valueProp: "id",
    labelProp: "name",
  });
};
